import { GetRecipesMeta, GetRecipesPayload } from 'types/store/GetRecipes';
import { createAsyncReducer } from 'utils/Redux';

import { getRecipesActions } from '../actions';

export default createAsyncReducer<GetRecipesMeta, GetRecipesPayload>(getRecipesActions);
